import type { CodexEntryView } from '@aztec-realms/shared-types';

import { generatedRuntimeAssetManifest, type GeneratedRuntimeAsset } from './game/asset-manifest';

// Presentation only: never infer ownership, rewards or mastery from these assets.
const familyArt = new Map<string, GeneratedRuntimeAsset>([
  ['sun', generatedRuntimeAssetManifest.sunFamilyRelief],
  ['jaguar', generatedRuntimeAssetManifest.jaguarFamilyRelief],
  ['rain', generatedRuntimeAssetManifest.rainFamilyRelief],
  ['maize', generatedRuntimeAssetManifest.maizeFamilyRelief],
  ['water', generatedRuntimeAssetManifest.waterFamilyRelief],
  ['serpent', generatedRuntimeAssetManifest.serpentFamilyRelief],
]);

/** Public family identity is not a discovery or a mastery award. */
export function codexFamilyIllustration(familyId: string) {
  return familyArt.get(familyId);
}

export function codexRestored(entry: CodexEntryView) {
  return entry.status === 'decoded' || entry.status === 'mastered';
}

export function codexIllustration(entry: CodexEntryView) {
  return codexRestored(entry) ? familyArt.get(entry.familyId) : undefined;
}

const profileOrder = ['tutorial', 'common', 'advanced', 'mastery'];

export function codexProfileOrder(code: string) {
  const index = profileOrder.indexOf(code);
  return index < 0 ? profileOrder.length : index;
}

export function codexProfileLabel(code: string) {
  return code === 'tutorial' ? 'First restoration' : code.charAt(0).toUpperCase() + code.slice(1);
}

export function codexTargetLabel(code: string) {
  const labels: Record<string, string> = {
    solve: 'Restore the glyph',
    no_hint: 'Without hints',
    par_moves: 'Within the move target',
    resonance: 'Connect the resonance path',
  };
  return labels[code] ?? code.replaceAll('_', ' ');
}
